import {IconEnum} from "./Enum";

export default class Materials {

    backgroundTone: string;
    courseMaterialDesign: string;
    courseMaterialDesignName: string;
    courseMaterialId: string;
    designSort: number;
    fontTone: string;
    id: string;
    isMain: boolean;
    lastUpdateTime: number;
    lastUpdatorId: string;
    lessonStage: number;
    size: number;
    name: string;
    path: string;


    constructor(id: string,
                name: string,
                path: string,
                size: number,
                courseMaterialId: string,
                courseMaterialDesign: string,
                courseMaterialDesignName: string,
                designSort: number,
                isMain: boolean,
                lessonStage: number,
                fontTone: string,
                backgroundTone: string,
                lastUpdatorId: string,
                lastUpdateTime: number) {
        this.id = id;
        this.name = name;
        this.path = path;
        this.size = size;
        this.courseMaterialId = courseMaterialId;
        this.courseMaterialDesign = courseMaterialDesign;
        this.courseMaterialDesignName = courseMaterialDesignName;
        this.courseMaterialDesignName = courseMaterialDesignName;
        this.courseMaterialDesignName = courseMaterialDesignName;
        this.designSort = designSort;
        this.fontTone = fontTone;
        this.isMain = isMain;
        this.lastUpdateTime = lastUpdateTime;
        this.lastUpdatorId = lastUpdatorId;
        this.lessonStage = lessonStage;
        this.backgroundTone = backgroundTone;
    }

    get icon(): string {
        if (this.path) {
            const number = this.path.lastIndexOf(".");
            if (number != -1) {
                const z = this.path.substr(number + 1, this.path.length - 1);
                let icon = "";
                switch (z) {
                    case "pdf":
                        icon = IconEnum.pdf;
                        break;
                    case "xls":
                    case "xlsx":
                        icon = IconEnum.excel;
                        break;
                    case "ppt":
                    case "pptx":
                        icon = IconEnum.ppt;
                        break;
                    case "doc":
                    case "docx":
                        icon = IconEnum.word;
                        break;
                    case "zip":
                    case "rar":
                    case "7z":
                        icon = IconEnum.zip;
                        break;
                    case "txt":
                        icon = IconEnum.txt;
                        break;
                    case "jpg":
                    case "jpeg":
                    case "png":
                    case "gif":
                    case "svg":
                        icon = IconEnum.pic;
                        break;
                    case "mp3":
                        icon = IconEnum.audio;
                        break;
                    case "mp4":
                        icon = IconEnum.video;
                        break;
                    default:
                        icon = IconEnum.unknown;
                }
                return icon;
            }
        }
        return IconEnum.unknown;
    }

    download(): void {
        // console.log(this.path)
        if (this.path) {
            // const link = document.createElement('a')
            // link.style.display = 'none'
            // // 获取文件名
            // // download 属性定义了下载链接的地址而不是跳转路径
            // link.setAttribute('download', this.name)
            // link.download =  this.name
            // link.href = this.path
            // document.body.appendChild(link)
            // link.target = "_new";
            // link.click();
            // document.body.removeChild(link);
            const name = this.name;
            const x = new XMLHttpRequest();
            x.open("GET", this.path, true);
            x.responseType = 'blob';
            x.onload = function (e) {
                //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                const url = window.URL.createObjectURL(x.response)
                const a = document.createElement('a');
                a.href = url
                a.download = name;
                a.click()
            }
            x.send();
        }
    }


};


